import React from 'react';
import styles from './Projects.module.css';
import ProjectCard from './ProjectCard';
import Margin from '../Margin';

const Projects = () => {
    const projects = [
        {
            title: 'Polaris Engine',
            languages: 'Python',
            linesOfCode: '5000+ lines',
            date: '2026/02/20',
            description:
                'Made $170k with this. Half-automatic stock searcher and risk management system.',
            projectLink: 'https://github.com/Quinsh/polaris_engine',
            image: process.env.PUBLIC_URL + '/images/projects/polaris_engine.jpg',
        },
        {
            title: 'RSA Encrypted Messenger',
            languages: 'C',
            linesOfCode: '1141 lines',
            date: '2024/12/20',
            description:
                "An RSA based end-to-end encrypted messaging program for local networks, especially Grinnell Colleges' MATLAN. Messages are saved locally using file system. Multithreading is used for encryption/decryption and bi-directional message sending.",
            projectLink: 'https://github.com/yashmalikk/CSC213_Final_Project',
            image: process.env.PUBLIC_URL + '/images/projects/rsa-messenger.png',
        },
        {
            title: 'Neural Network Implementation',
            languages: 'C++',
            linesOfCode: '1133 lines',
            date: '2024/08/24',
            description:
                'Implementing neural network in C++. Benchmarked way how we use Keras: you can create models, add layers, specify learning rate, use different activations (RELU, SIGMOID, TANH, LINEAR, SOFTMAX), use different cost functions (MSE, BinaryCrossEntropy, CategoricalCrossEntropy), and choose among Stochastic Gradient Descent, Mini-Batch, and Batch.',
            projectLink: 'https://github.com/Quinsh/NeuralNetworkCpp',
            image: process.env.PUBLIC_URL + '/images/projects/neural-network.png',
        },
        {
            title: 'Fast Sudoku Solver',
            languages: 'C++',
            linesOfCode: '1118 lines',
            date: '2024/08/14',
            description:
                "Implementing Heuristics Backtracking for fast sudoku solving. Reference paper: 'A study of Sudoku solving algorithms'. Heuristics like Naked Pair, Naked Tuple, Hidden Pair, Hidden Tuple were used for constraint propagation. Used OpenCV for visual interface.",
            projectLink: 'https://github.com/Quinsh/FastSudokuSolver',
            image: process.env.PUBLIC_URL + '/images/projects/sudoku-solver.png',
        },
    ];

    return (
        <div id="projects" className={styles.root}>
            <div className={styles.inner}>
                <h2>Projects</h2>
                <ul className={styles.grid}>
                    {projects.map((project, index) => (
                        <li key={index} className={styles.gridItem}>
                            <ProjectCard {...project} />
                        </li>
                    ))}
                </ul>
                <Margin size={2} />
            </div>
        </div>
    );
};

export default Projects;
